/* eslint-disable react/jsx-max-props-per-line */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import DefaultModal from '../nsmp-view/DefaultModal';
import NsmpAnexoModal from '../nsmp-view/NsmpAnexoModal';
import DigitacaoTab from './components/DigitacaoTab';
import { useParticipacaoMode } from './hooks/useParticipacaoMode';
import { isAnexoNsmp } from '../utils/nsmpRowTypes';
import * as selectorsNsir from '../../../../store/nsir/reducer';
import * as selectorsNsmp from '../../../../store/nsmp/reducer';
import * as selectorsAuth from '../../../../store/auth/reducer';

const MtBtNsmpModal = (props) => {
  const {
    nsirData,
    nsmps: reduxNsmps,
    contextNsmps,
    selectedId,
    readOnly,
    participacaoMode: participacaoModeProp,
    podeForcarEnvio,
    userId,
    userRole,
    nsmpSelected,
    onEnviado,
  } = props;

  const nsmps = contextNsmps || reduxNsmps;

  const [digitacaoRefreshKey, setDigitacaoRefreshKey] = useState(0);

  const participacaoModeFromHook = useParticipacaoMode({
    nsirData,
    userId,
    userRole,
    nsmps,
  });
  const participacaoMode = participacaoModeProp || participacaoModeFromHook;

  const listRow = selectedId ? (nsmps || []).find((r) => r.id === selectedId) : null;
  const loadedRow = selectedId && nsmpSelected && nsmpSelected.id === selectedId ? nsmpSelected : null;
  const nsmpRow = loadedRow || listRow;
  const readOnlyEffective = readOnly || participacaoMode === 'CONSULTA';
  const isAnexo = [listRow, loadedRow].some((row) => row && isAnexoNsmp(row));

  if (isAnexo) {
    return <NsmpAnexoModal {...props} readOnly={readOnlyEffective} />;
  }

  const extraContent = selectedId ? (
    <DigitacaoTab
      key={digitacaoRefreshKey}
      nsmpId={selectedId}
      nsmpRow={nsmpRow}
      readOnly={readOnlyEffective}
      participacaoMode={participacaoMode}
      podeForcarEnvio={podeForcarEnvio}
      userId={userId}
      onReprocessDone={() => setDigitacaoRefreshKey((k) => k + 1)}
      onEnviado={onEnviado}
    />
  ) : null;

  return <DefaultModal {...props} readOnly={readOnlyEffective} extraContent={extraContent} />;
};

MtBtNsmpModal.propTypes = {
  nsirData: PropTypes.object.isRequired,
  nsmps: PropTypes.array,
  contextNsmps: PropTypes.array,
  nsmpSelected: PropTypes.object,
  selectedId: PropTypes.string,
  readOnly: PropTypes.bool,
  participacaoMode: PropTypes.string,
  podeForcarEnvio: PropTypes.bool,
  userId: PropTypes.string,
  userRole: PropTypes.string,
  onEnviado: PropTypes.func,
};

MtBtNsmpModal.defaultProps = {
  nsmps: [],
  contextNsmps: null,
  nsmpSelected: {},
  selectedId: undefined,
  readOnly: false,
  participacaoMode: null,
  podeForcarEnvio: false,
  userId: null,
  userRole: null,
  onEnviado: undefined,
};

const mapStateToProps = (state) => ({
  nsirData: selectorsNsir.getNsirSelected(state),
  nsmpSelected: selectorsNsmp.getNsmpSelected(state),
  nsmps: selectorsNsmp.getNsmps(state),
  userId: selectorsAuth.getUserId(state),
  userRole: selectorsAuth.getRole(state),
});

export default connect(mapStateToProps)(MtBtNsmpModal);
